/** Mono-900 as defined on the light scale; invariant when `.dark` mirrors palette tokens. */
export const darkMono900Physical = 'var(--bfc-v2-color-mono-900-physical, #262626)';

export const dark = {
  100: 'var(--bfc-v2-color-mono-100, #FAFAFA)',
  200: 'var(--bfc-v2-color-mono-200, #F5F5F5)',
  300: 'var(--bfc-v2-color-mono-300, #E5E5E5)',
  400: 'var(--bfc-v2-color-mono-400, #D4D4D4)',
  500: 'var(--bfc-v2-color-mono-500, #A3A3A3)',
  600: 'var(--bfc-v2-color-mono-600, #737373)',
  700: 'var(--bfc-v2-color-mono-700, #525252)',
  800: 'var(--bfc-v2-color-mono-800, #404040)',
  900: 'var(--bfc-v2-color-mono-900, #262626)',
  1000: 'var(--bfc-v2-color-mono-1000, #171717)',
  DEFAULT: 'var(--bfc-v2-color-mono-900, #262626)', // 900
};
